import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { IClientNumber } from "src/app/models/client/client-number";
import { ICoverPage } from "src/app/models/cover-page/cover-page";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-edit-cover-page-modal",
  templateUrl: "./edit-cover-page-modal.component.html",
})
export class EditCoverPageModalComponent {
  @Input() isSaving = false;
  @Input() coverPage: ICoverPage | null = null;
  @Input() clientNumbers: IClientNumber[] = [];

  @Output() close = new EventEmitter();
  @Output() submit = new EventEmitter<Partial<ICoverPage>>();

  constructor(private readonly _modalService: ModalService) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.EditCoverPage;
  }

  onClose() {
    if (this.isSaving) {
      return;
    }
    this._modalService.closeModal();
    this.close.emit();
  }

  onSubmit(coverPage: ICoverPage) {
    if (this.isSaving) {
      return;
    }
    const changes: Partial<ICoverPage> = {};
    for (const key of Object.keys(coverPage) as (keyof ICoverPage)[]) {
      if (coverPage[key] !== this.coverPage?.[key]) {
        changes[key] = coverPage[key];
      }
    }
    if (Object.keys(changes).length > 0) {
      this.submit.emit(changes);
    } else {
      this.onClose();
    }
  }
}
